// Storage for the first-visit "How to read a deal" guide (components/DealCardGuide.tsx).
export const DEAL_GUIDE_SEEN_KEY = "dealhawk_deal_guide_seen";
export const DEAL_GUIDE_ATTR = "data-deal-guide";

// Seen per account, so another account on the same browser still gets the guide.
export const dealGuideSeenKey = (userId: string) => `${DEAL_GUIDE_SEEN_KEY}:${userId.toLowerCase()}`;

export function dealGuideSeen(userId: string): boolean {
  try {
    return Boolean(window.localStorage.getItem(dealGuideSeenKey(userId)));
  } catch {
    // Storage blocked: don't nag on every visit.
    return true;
  }
}

export function markDealGuideSeen(userId: string): void {
  try {
    window.localStorage.setItem(dealGuideSeenKey(userId), String(Date.now()));
  } catch {
    /* storage unavailable */
  }
}

/** Show the guide again for this account. */
export function resetDealGuide(userId: string): void {
  try {
    window.localStorage.removeItem(dealGuideSeenKey(userId));
  } catch {
    /* storage unavailable */
  }
}
